/**
 * Application base path constant
 */
export const BASE_PATH = '/services/itopfiveui';
